import React from "react";
import "./IssueMediaUploader.css";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import UploadMediaList from "../UploadMediaList/UploadMediaList";
import {
  loadUploadItemRequestAction,
  setUploadItemAppendDataAction,
  uploadMediaItemRequestAction
} from "../../redux/actions/issueMediaUploader";
import { addYoutube } from "../../api/issues";
import { generateUniqueID } from "../../utils/utils";

class IssueMediaUploader extends React.Component {
  constructor(props) {
    super(props);

    this.handleYoutubeUriEntered = this.handleYoutubeUriEntered.bind(this);
    this.handleAddYoutubeUri = this.handleAddYoutubeUri.bind(this);
    this.handleAddingVideoFiles = this.handleAddingVideoFiles.bind(this);
    this.handleAddingAudioFiles = this.handleAddingAudioFiles.bind(this);

    this.state = {
      youtubeUri: "",
      youtubeLoading: false
    };
  }

  componentDidMount() {
    const {
      isPdf,
      issueID,
      loadedIsPdf,
      loadedIssueID,
      loadUploadItemRequestAction
    } = this.props;

    if (loadedIsPdf !== isPdf || loadedIssueID !== issueID) {
      loadUploadItemRequestAction(issueID, isPdf);
    }
  }

  handleYoutubeUriEntered(event) {
    if (this.state.youtubeLoading) {
      return;
    }

    this.setState({ youtubeUri: event.target.value });
  }

  handleAddingVideoFiles(files) {
    let i = 0;
    for (i = 0; i < files.length; i++) {
      const file = files[i];
      const dict = {
        mediaType: "video",
        serverData: null,
        filename: file.name
      };

      const id = generateUniqueID();
      this.props.setUploadItemAppendDataAction({ id: id, media: dict });

      const { isPdf, issueID } = this.props;
      this.props.uploadMediaItemRequestAction(
        id,
        file,
        issueID,
        isPdf,
        file.name,
        "video"
      );
    }
  }

  async handleAddYoutubeUri() {
    const { youtubeUri, youtubeLoading } = this.state;
    const { isPdf, issueID, setUploadItemAppendDataAction } = this.props;

    if (youtubeLoading) {
      return;
    }

    if (!youtubeUri.startsWith("https://www.youtube.com/")) {
      toast.error("Please Enter Youtube URL");
      return;
    }

    this.setState({ youtubeLoading: true });

    try {
      const serverData = await addYoutube(issueID, isPdf, youtubeUri);

      const dict = {
        mediaType: "video",
        serverData: serverData
      };

      const id = generateUniqueID();
      setUploadItemAppendDataAction({ id: id, media: dict });
      this.setState({ youtubeUri: "" });
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ youtubeLoading: false });
  }

  handleAddingAudioFiles(files) {
    let i = 0;
    for (i = 0; i < files.length; i++) {
      const file = files[i];
      const dict = {
        mediaType: "audio",
        serverData: null,
        filename: file.name
      };

      const id = generateUniqueID();
      this.props.setUploadItemAppendDataAction({ id: id, media: dict });

      const { isPdf, issueID } = this.props;
      this.props.uploadMediaItemRequestAction(
        id,
        file,
        issueID,
        isPdf,
        file.name,
        "audio"
      );
    }
  }

  renderSwitch() {
    const {
      isPdf,
      issueID,
      loadedIsPdf,
      loadedIssueID,
      errMsg,
      mediaIDs
    } = this.props;
    const isLoading = isPdf !== loadedIsPdf || issueID !== loadedIssueID;

    if (isLoading) {
      return (
        <div className="upload_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    } else if (errMsg != null) {
      return (
        <div className="upload_spinner_container">
          <Alert variant="danger">{errMsg}</Alert>
        </div>
      );
    } else {
      return <UploadMediaList uploadIDs={mediaIDs} />;
    }
  }

  render() {
    const { isPdf, issueID, loadedIsPdf, loadedIssueID } = this.props;
    const isLoading = isPdf !== loadedIsPdf || issueID !== loadedIssueID;

    return (
      <Container className="issue_media_uploader">
        <Form.Row>
          <Col xs="9" sm="9" md="9" lg="10">
            <Form.Control
              type="text"
              value={this.state.youtubeUri}
              placeholder="https://www.youtube.com/watch?v=7SmfPhWdOq0"
              onChange={this.handleYoutubeUriEntered}
            />
          </Col>
          <Col xs="3" sm="3" md="3" lg="2">
            <Button
              className="add_youtube_btn"
              variant="info"
              onClick={this.handleAddYoutubeUri}
              disabled={isLoading || this.state.youtubeLoading}
            >
              {this.state.youtubeLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "+Youtube"
              )}
            </Button>
          </Col>
        </Form.Row>
        <Row>
          <Col sm="12" md="6">
            <Dropzone onDrop={this.handleAddingVideoFiles} disabled={isLoading}>
              {({ getRootProps, getInputProps }) => (
                <div className="media_upload_zone" {...getRootProps()}>
                  <input {...getInputProps()} />
                  <span>Drop/Click for video files</span>
                </div>
              )}
            </Dropzone>
          </Col>
          <Col sm="12" md="6">
            <Dropzone onDrop={this.handleAddingAudioFiles} disabled={isLoading}>
              {({ getRootProps, getInputProps }) => (
                <div className="media_upload_zone" {...getRootProps()}>
                  <input {...getInputProps()} />
                  <span>Drop/Click for audio files</span>
                </div>
              )}
            </Dropzone>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>

        {this.renderSwitch()}
      </Container>
    );
  }
}

const mapState = state => {
  const { issueMediaUploader } = state;

  return issueMediaUploader;
};

const mapDispatch = {
  loadUploadItemRequestAction,
  setUploadItemAppendDataAction,
  uploadMediaItemRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(IssueMediaUploader);
